import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { registerLocaleData } from '@angular/common';
import 'hammerjs';

import localeAr from '@angular/common/locales/ar';
import localeCs from '@angular/common/locales/cs';
import localeDe from '@angular/common/locales/de';
import localeDa from '@angular/common/locales/da';
import localeEs from '@angular/common/locales/es';
import localeFi from '@angular/common/locales/fi';
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';
import localeHr from '@angular/common/locales/hr';
import localeHu from '@angular/common/locales/hu';
import localeHe from '@angular/common/locales/he';
import localeIt from '@angular/common/locales/it';
import localeNl from '@angular/common/locales/nl';
import localeNo from '@angular/common/locales/no';
import localePl from '@angular/common/locales/pl';
import localeRu from '@angular/common/locales/ru';
import localeSv from '@angular/common/locales/sv';
import localeSl from '@angular/common/locales/sl';
import localeSk from '@angular/common/locales/sk';
import localeUk from '@angular/common/locales/uk';

import { AuthService } from './app/auth.service';

registerLocaleData(localeAr, 'ar');
registerLocaleData(localeCs, 'cs');
registerLocaleData(localeDe, 'de');
registerLocaleData(localeDa, 'da');
registerLocaleData(localeEs, 'es');
registerLocaleData(localeFi, 'fi');
registerLocaleData(localeFr, 'fr');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeHr, 'hr');
registerLocaleData(localeHu, 'hu');
registerLocaleData(localeHe, 'he');
registerLocaleData(localeIt, 'it');
registerLocaleData(localeNl, 'nl');
registerLocaleData(localeNo, 'no');
registerLocaleData(localePl, 'pl');
registerLocaleData(localeRu, 'ru');
registerLocaleData(localeSv, 'sv');
registerLocaleData(localeSl, 'sl');
registerLocaleData(localeSk, 'sk');
registerLocaleData(localeUk, 'uk');

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...appConfig.providers!,
    provideOAuthClient()
  ]
}).then(appRef => {
  const injector = appRef.injector;
  const authService = injector.get(AuthService);
  authService.handleLoginCallback();
}).catch(err => console.error(err));
